import { Switch } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../variables/api/axiosInstance";
import { API_URL, TOKEN } from "../../variables/constants";

const AddGarantie = ({
  show,
  handleClose,
  editMode = false,
  codeId,
  selectedGarantie,
}) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nom, setNom] = useState("");
  const [commentaire, setCommentaire] = useState("");
  const [selectedCategorie, setSelectedCategorie] = useState("");
  const [obligatoire, setObligatoire] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);

  useEffect(() => {
    if (show && selectedGarantie) {
      setNom(selectedGarantie.nom || "");
      setCommentaire(selectedGarantie.commentaire || "");
      setObligatoire(selectedGarantie.obligatoire || false);
      setSelectedCategorie(
        selectedGarantie.categorie?.categorieId?.toString() || ""
      );
    }

    if (editMode && selectedGarantie?.codeId) {
      setIsDataLoading(true);
      axiosInstance
        .get(`/api/garantie/codeId/${selectedGarantie.codeId}`)
        .then((res) => {
          const { nom, commentaire, obligatoire, categorie } = res.data;
          setNom(nom);
          setCommentaire(commentaire);
          setObligatoire(obligatoire);
          setSelectedCategorie(categorie?.categorieId?.toString() || "");
        })
        .catch((err) => {
          console.error(err);
          toast.error("Erreur lors de la récupération de la garantie");
        })
        .finally(() => {
          setIsDataLoading(false);
        });
    }
  }, [show, editMode, selectedGarantie]);

  useEffect(() => {
    axiosInstance
      .get(`/api/categorie`)
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de la récupération des catégories");
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!nom || !selectedCategorie) {
      toast.error("Veuillez remplir tous les champs requis.");
      return;
    }

    setLoading(true);

    const selectedCat = categories.find(
      (c) => c.categorieId === parseInt(selectedCategorie)
    );

    const gar = {
      nom,
      commentaire,
      obligatoire,
      categorie: selectedCat,
    };

    // En mode édition, on transmet aussi le codeId
    if (editMode && selectedGarantie?.codeId) {
      gar.codeId = selectedGarantie.codeId;
    }

    const apiMethod = editMode ? axios.put : axios.post;
    const apiUrl = `${API_URL}/api/garantie`;

    apiMethod(apiUrl, JSON.stringify(gar), {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        toast.success(
          editMode
            ? "Garantie modifiée avec succès"
            : "Garantie ajoutée avec succès"
        );
        handleClose();
      })
      .catch((err) => {
        console.error("Erreur lors de l'envoi :", err);
        toast.error(
          editMode
            ? "Erreur lors de la modification"
            : "Erreur lors de l'ajout"
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button
          type="button"
          className="btn-close btn-primary"
          onClick={handleClose}
        ></button>
        <div className="text-center mb-4">
          <h4 className="address-title mb-2">
            {editMode ? "Modifier la garantie" : "Ajouter une garantie"}
          </h4>
          <p className="add-subtitle">
            {editMode
              ? "Modifier une garantie existante"
              : "Ajouter une nouvelle garantie"}
          </p>
        </div>
        <form className="row g-3" onSubmit={onSubmit}>
          <div className="col-12">
            <label className="form-label">Nom</label>
            <input
              type="text"
              className="form-control"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              disabled={isDataLoading}
              placeholder="Nom de la garantie"
            />
          </div>
          <div className="col-12">
            <label className="form-label">Catégorie</label>
            <select
              className="form-select"
              value={selectedCategorie}
              onChange={(e) => setSelectedCategorie(e.target.value)}
              disabled={isDataLoading}
            >
              <option value="">Sélectionner une catégorie</option>
              {categories.map((cat) => (
                <option key={cat.categorieId} value={cat.categorieId}>
                  {cat.nom}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              value={commentaire}
              onChange={(e) => setCommentaire(e.target.value)}
              placeholder="Description de la garantie"
              disabled={isDataLoading}
            />
          </div>
          <div className="col-12">
            <label className="form-label">Garantie obligatoire ?</label>
            <br />
            <Switch
              checkedChildren="OUI"
              unCheckedChildren="NON"
              checked={obligatoire}
              onChange={setObligatoire}
              disabled={isDataLoading}
            />
          </div>
          <div className="col-12 text-center">
            <button
              type="submit"
              className="btn btn-primary me-2"
              disabled={loading || isDataLoading}
            >
              {loading ? "Enregistrement..." : "Enregistrer"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isDataLoading}
            >
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddGarantie;
